import { render } from "./clientHistory.vue?vue&type=template&id=470ae246&scoped=true"
import script from "./clientHistory.vue?vue&type=script&lang=js"
export * from "./clientHistory.vue?vue&type=script&lang=js"

import "./clientHistory.vue?vue&type=style&index=0&id=470ae246&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470ae246"]])

export default __exports__